import { render, staticRenderFns } from "./SettingsCustomfields.vue?vue&type=template&id=2b6994f8&scoped=true&"
import script from "./SettingsCustomfields.vue?vue&type=script&lang=ts&"
export * from "./SettingsCustomfields.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCustomfields.vue?vue&type=style&index=0&id=2b6994f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6994f8",
  null
  
)

export default component.exports